import { ArrowLeft } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

import { cn } from "@/shared/lib/cn";

interface Props {
  /** Explicit destination. Use whenever the parent is well-defined (edit →
   *  detail, applicants → detail). Renders as a real anchor so middle-click
   *  / open-in-new-tab work. */
  to?: string;
  /** Override the default "Back" copy — e.g. "Back to applicants". */
  label?: string;
  className?: string;
}

/** Small back-affordance for detail pages. Falls back to browser history when
 *  no explicit `to` is given — useful when the user might have arrived from
 *  several places (e.g. a shift detail reachable from the feed, "my apps",
 *  or search results). */
export function BackLink({ to, label = "Back", className }: Props) {
  const navigate = useNavigate();
  const cls = cn(
    "inline-flex items-center gap-1 text-sm text-copy-muted hover:text-copy",
    className,
  );

  if (to) {
    return (
      <Link to={to} className={cls}>
        <ArrowLeft className="h-4 w-4" />
        {label}
      </Link>
    );
  }
  return (
    <button type="button" onClick={() => navigate(-1)} className={cls}>
      <ArrowLeft className="h-4 w-4" />
      {label}
    </button>
  );
}
